/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 3
// module chunks = 0